import { Box, keyframes } from '@chakra-ui/react';
import React from 'react';

const pulseAnimation = keyframes`
  0% { background-color: rgba(255, 255, 255, 0.7); }
  50% { background-color: rgba(255, 255, 255, 0.9); }
  100% { background-color: rgba(255, 255, 255, 0.7); }
`;

const Loader = ({ isAbsolute = false }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        position: isAbsolute ? 'absolute' : 'fixed',
        top: 0,
        left: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        zIndex: 10,
        animation: `${pulseAnimation} 3s infinite ease-in-out`,
      }}
    >
      <span className="loader"></span>
    </Box>
  );
};

export default Loader;
